import { FieldValues, UseFormWatch } from 'react-hook-form';

import { useUsersContext } from 'contexts/UsersContext';

import { User } from 'types/api/users.type';

import { useCountries, usePostalCode } from 'hooks';

import { FormItem } from 'sections/EditForm';

const useFormData = (watch?: UseFormWatch<FieldValues>, user?: User): FormItem[] => {
  const { isShippingAddressSet, isShippingAddress } = useUsersContext();

  const country = watch && watch('billingAddress.country');

  const { countryCode, countryList } = useCountries(country);

  const { postalCodes } = usePostalCode(countryCode!);

  return [
    {
      name: 'is_ship_address_different',
      type: 'checkbox',
      label: 'Different shipping address',
      margin: '0 0 0 14rem',
      asSingleCheckbox: true,
      onChange: () => {
        isShippingAddressSet(!isShippingAddress);
      },
      defaultChecked: typeof user?.shippingAddress !== 'undefined',
      isCheckIcon: true,
    },
    {
      label: 'Country',
      type: 'select',
      options: countryList,
      name: 'billingAddress.country',
    },
    {
      label: 'State',
      name: 'billingAddress.region',
    },
    {
      label: 'Post Code',
      name: 'billingAddress.postCode',
      options: postalCodes,
      type: 'postCodeSelect',
    },
    {
      label: 'address',
      name: 'billingAddress.street',
    },
    {
      label: 'City',
      name: 'billingAddress.city',
    },
    {
      label: 'Province',
      name: 'billingAddress.province',
    },
    {
      label: 'telephone number',
      name: 'billingAddress.phoneNumber',
    },
  ];
};

export { useFormData };
